import { createAsyncThunk } from '@reduxjs/toolkit';

import { loadApp } from '../application.middleware';
import api, { MilestoneApp, MilestonePayload } from 'api';

export const loadMilestones = createAsyncThunk(
    'api/application/{application_id}/milestones',
    async (appId: string) => await api.application.milestones.get(appId)
);

export const updateMilestone = createAsyncThunk(
    'api/application/{application_id}/update-milestone',
    async ({ appID, milestones }: { appID: string; milestones: MilestoneApp[] }, { dispatch }) => {
        await api.application.milestones.put(appID, milestones);
        dispatch(loadApp(appID));
    }
);

export const updateMilestones = createAsyncThunk(
    'api/application/{application_id}/milestones(PUT)',
    async ({ appID, payload }: { appID: string; payload: MilestonePayload[] }) =>
        await api.application.milestones.put(appID, payload)
);

export const createMilestones = createAsyncThunk(
    'api/application/{application_id}/milestones(POST)',
    async (
        {
            appID,
            payload,
            notifyClient,
        }: { appID: string; payload: MilestonePayload[]; notifyClient?: boolean },
        { dispatch }
    ) => {
        const config = notifyClient === undefined ? undefined : { params: { notifyClient } };
        await api.application.milestones.post(appID, payload, config);
        dispatch(loadMilestones(appID));
    }
);

export const createMilestone = createAsyncThunk(
    'api/application/{application_id}/milestone(POST)',
    async ({ appID, payload }: { appID: string; payload: MilestonePayload }, { dispatch }) => {
        const resp = await api.application.milestone.post(appID, payload);
        dispatch(loadMilestones(appID));
        return resp;
    }
);

export const deleteMilestone = createAsyncThunk(
    'api/application/{application_id}/milestone(POST)',
    async ({ appID, milestoneID }: { appID: string; milestoneID: string }, { dispatch }) => {
        await api.application.milestone.delete(appID, milestoneID);
        dispatch(loadMilestones(appID));
    }
);
